<template>
  <Wrapper
    :autoedit="edit"
    :disabled="disabled"
    :pendingGoodsInspectionCode="pendingGoodsInspectionCode"
    :pendingGoodsCode="pendingGoodsCode"
    @add-success="addSuccess"
  />
</template>
<script>
import Wrapper from './wrapper.vue'
export default {
  name: 'quality-production-inspection-detail',
  components: { Wrapper },
  computed: {
    params() {
      return this.$route.params
    },
    query() {
      return this.$route.query
    },
    pageType() {
      return this.params.pageType
    },
    edit() {
      return this.pageType === 'edit'
    },
    disabled() {
      return this.pageType === 'detail'
    },
    pendingGoodsInspectionCode() {
      return this.params.pendingGoodsInspectionCode
    },
    pendingGoodsCode() {
      return this.query.pendingGoodsCode
    },
  },
  methods: {
    addSuccess(body) {
      if (!body) return

      const { pendingGoodsInspectionCode, pendingGoodsInspectionNo } = body

      this.$router.replace({
        name: 'quality-production-inspection-detail',
        params: { pendingGoodsInspectionCode, pageType: 'edit' },
        query: { pendingGoodsInspectionNo },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
